import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations/index.ts";

export interface TogglerIconProps {
    icon: "plus" | "minus";
}

export const TogglerIcon = (props: TogglerIconProps) => {
    const { icon } = props;
    return <div css={togglerIconCss} className={icon} aria-hidden="true" />;
};

const togglerIconCss = css({
    "background": wacToken("color.extended.blue800"),
    "borderRadius": "50%",
    "height": "24px",
    "transition": "transform .25s linear",
    "width": "24px",
    "minWidth": "24px",

    "&.plus": {
        transform: "rotate(90deg)"
    },

    "&.minus": {
        transform: "rotate(180deg)"
    },

    "&.plus:before, &.plus:after, &.minus:before": {
        borderRadius: "10px",
        content: "",
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        insetInlineEnd: 0,
        insetBlockEnd: 0,
        background: wacToken("color.neutral.light0"),
        margin: "auto 5px",
        height: "2px"
    },

    "&.plus:before": {
        height: "auto",
        width: "2px",
        margin: "5px auto"
    }
});
